<template>
  <AuthTemplate>
    <div slot="body">
      <h1 class="h4">
        Forgotten Password
      </h1>
      <p class="text">
        Please provide your email and we’ll send you a link to set your new password.
      </p>
      <div class="input-group">
        <input
          id="email"
          v-model="email"
          type="email"
          placeholder="Email"
          name="email"
        >
      </div>
      <VueRecaptcha
        ref="recaptcha"
        class="recaptcha"
        size="invisible"
        :sitekey="$config.reCaptchaSiteKey"
        :load-recaptcha-script="true"
        @verify="requestNewPassword"
        @expired="onRecaptchaExpired"
      >
        <button class="btn-primary btn-lg" :disabled="disabled">
          Request new password
        </button>
      </VueRecaptcha>
    </div>
  </AuthTemplate>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import VueRecaptcha from 'vue-recaptcha';
import AuthTemplate from '../components/AuthTemplate';
import IconMail from '../assets/svg/mail.svg?vue-component';

export default {
  components: {
    AuthTemplate, VueRecaptcha,
  },
  mixins: [global],
  middleware({ store, redirect }) {
    if (store.state.auth.user) {
      redirect('/');
    }
  },
  data() {
    return {
      email: '',
      checkMail: false,
      checkMailText:
        "<span class='check-mail-text'>We've sent you an email with instructions to reset your password. Please make sure it didn't wind up in your Junk mail. If you aren't receiving our password reset emails, please</span>",
      disabled: true,
    };
  },
  head() {
    const meta = {
      fullPath: `${this.$config.siteUrl}${this.$route.fullPath}`,
      metaTitle: 'Forgotten password',
      robots: 'noindex, nofollow',
    };

    return {
      titleTemplate: `${meta.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(meta),
    };
  },
  mounted() {
    this.disabled = false;
    this.checkMail = false;
  },
  methods: {
    async requestNewPassword() {
      this.disabled = true;
      try {
        const res = await this.$axios.$post('/auth/forget-password', {
          email: this.email,
        });
        if (res !== undefined) {
          this.checkMail = true;
          await this.$store.dispatch('modals/open', {
            name: 'confirm',
            imgSrc: IconMail,
            title: 'Check Your Mail',
            message: `${this.checkMailText} <a href="mailto:appsupport@365datascience.com">contact customer support</a>`,
            cancel: '',
            confirm: 'Done',
          });
        }
      } catch (error) {
        await this.$store.dispatch('modals/open', {
          name: 'default',
          title: error.response.data.message,
        });
      }
    },
    onRecaptchaExpired() {
      this.disabled = false;
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
h1.h4 {
  margin-top: 0;
  text-align: center;
}

p.text {
  font-size: 14px;
  color: var(--main-dark-light-4);
  margin: var(--spacing-22) 0;
  text-align: center;
}

.input-group:not(:last-of-type) {
  margin-bottom: var(--spacing-sm);
}

input {
  width: 100%;
  border-radius: 5px;
}

button {
  width: 100%;
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-20);
}
</style>
